module.exports = __webpack_public_path__ + "static/media/empathyExperiment.5bf57c01.jpg";